import { ElementRef, EventEmitter, Renderer2 } from '@angular/core';
import { CommonService } from '../../../app/common.service';
var ComponentQuestionnaireTag = (function () {
    function ComponentQuestionnaireTag(el, commonService, renderer) {
        this.el = el;
        this.commonService = commonService;
        this.renderer = renderer;
        this.outPutSelectedTag = new EventEmitter(); //回传标签
        this.selectedTag = ""; //用户选择的标签
    }
    ComponentQuestionnaireTag.prototype.ngOnInit = function () {
    };
    ComponentQuestionnaireTag.prototype.ngAfterViewInit = function () {
    };
    ComponentQuestionnaireTag.prototype.ngOnChanges = function (changes) {
        if (changes.questionnaireContext && changes.questionnaireContext.currentValue !== '') {
            this.commonService.setStorage('inputContext', this.questionnaireContext);
        }
    };
    // 选择标签
    ComponentQuestionnaireTag.prototype.selectTag = function (i) {
        var inputContext = this.commonService.getStorage('inputContext') ? this.commonService.getStorage('inputContext') : '';
        console.log(inputContext);
        var target = this.el.nativeElement.querySelector('.elem-' + i);
        if (target.classList.contains('active') == true) {
            this.renderer.removeClass(target, 'active');
            // this.selectedTagArray.splice(this.selectedTagArray.findIndex(item => item === this.questionnaireTagArray[i].description),1);
            // this.selectedTag = this.inputContext.replace(this.questionnaireTagArray[i].description+',', '');
            this.selectedTag = inputContext.replace(this.questionnaireTagArray[i].description + ',', '');
            console.log(this.selectedTag);
            this.commonService.setStorage('inputContext', this.selectedTag);
        }
        else {
            if (inputContext.length >= 300) {
                return false;
            }
            else {
                this.renderer.addClass(target, 'active');
                this.selectedTag = inputContext + this.questionnaireTagArray[i].description + ',';
                // this.selectedTag += this.questionnaireTagArray[i].description+',';
            }
        }
        this.outPutSelectedTag.emit(this.selectedTag);
    };
    return ComponentQuestionnaireTag;
}());
export { ComponentQuestionnaireTag };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-tag/component.questionnaire-tag.ts.pre-build-optimizer.js